import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { ApiService } from '../../services/API/api.service';
import { AddressCompany, Open, typeInterface } from 'src/app/shared/Interfaces/company';
import { DOCUMENT } from '@angular/common';
import { ScrollService } from '../../services/Scroll/scroll.service';

@Component({
  selector: 'app-info-company',
  templateUrl: './info-company.component.html',
  styleUrl: './info-company.component.css'
})
export class InfoCompanyComponent implements OnInit, AfterViewInit, OnChanges{
  @ViewChild('offCanva') offCanva!: ElementRef
  @Input() openInfo: boolean = false;
  private typeParam!: typeInterface;
  @Output() closeInfo: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  nameCompany: string = '';
  company!: Company;
  opening!: Open;
  addressCompany!: AddressCompany;
  addressUrl: string = '';
  timesInfo: any;
  local: boolean = false;
  readOnlyState: boolean = false;
  offCanvasHeight: string | number = 'auto';
  initHeight: number = 675;
  localCounter: boolean = false;

  constructor(
    private connection: ConnectionService,
    public scrollService: ScrollService,
    @Inject(DOCUMENT) private document: Document,){
    this.connection.nameCompany$.subscribe((newNameCompany: string) => {
      this.nameCompany = newNameCompany;
    })
    this.connection.company$.subscribe((data) =>{
      this.company = data
      if(this.company){
        this.opening = this.company.company.open
        this.addressCompany = this.company.company.address;
        this.formattedAddress();
        this.validTimes()
      }
    })
    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam;
    })

    this.connection.readOnlyState$.subscribe((data) =>{
      this.readOnlyState = data;
    })
  }

  ngOnInit(): void {
    if(this.typeParam.type == 1 || this.typeParam.type == 2){
      this.local = true;
    }
    else{
      this.local = false;
    }

    if(this.typeParam.type == 3){
      this.localCounter = true;
    }
    else{
      this.localCounter = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['openInfo'].currentValue == true){
      this.scrollService.disableScroll();
    }
    else{
      this.scrollService.enableScroll();
    }
  }

  ngAfterViewInit(): void {
  }

  formattedAddress(){
    if(this.company){
      const address = this.company.company.address;
      const addressCompletted = `${address.street}, ${address.number} - ${address.district}, ${address.city} - ${address.state}, ${address.country}`;

      const addressCodificate = encodeURIComponent(addressCompletted);
      this.addressUrl = `https://www.google.com/maps/search/?api=1&query=${addressCodificate}`
    }

  }

  close(){
    this.openInfo = false;
    this.closeInfo.emit(false)
  }


  validTimes() {
    const { deliveryFrom, deliveryTo, counterFrom, counterTo } = this.company.company.times;
  
    this.timesInfo = {
      delivery: {
        active: !(deliveryFrom === 0 && deliveryTo === 0),
        label: this.formatTimeRange(deliveryFrom, deliveryTo)
      },
      counter: {
        active: !(counterFrom === 0 && counterTo === 0),
        label: this.formatTimeRange(counterFrom, counterTo)
      }
    };
  }
  
  private formatTimeRange(from: number, to: number): string {
    if (!from && !to) return '';
  
    if (from && to) {
      return `${this.formatMinutes(from)} - ${this.formatMinutes(to)}`;
    }
  
    const value = from || to;
    return this.formatMinutes(value);
  }
  
  private formatMinutes(minutes: number): string {
    if (!minutes) return '';
  
    if (minutes < 60) return `${minutes} min`;
  
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
  
    if (hours && mins) {
      return `${hours}h${mins}`;
    }
  
    return `${hours}h`;
  }
  
}
